var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#pattern0_2475_14125)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#paint0_radial_2475_14125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2475_14125",
    patternContentUnits: "objectBoundingBox",
    width: 0.0232639,
    height: 0.0555556
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2475_14125",
    transform: "scale(0.000347222 0.000555556)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2475_14125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 450) rotate(90) scale(450 584.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2475_14125",
    width: 67,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABkCAYAAADdY439AAAAAXNSR0IArs4c6QAABNZJREFUeF7tXD1T20AQtWZsComCwoGGgTapqVOn4gdQ4wJ+ERSm9g+gSp2ampoMDeCCAqnAzDjzPDpmc5zuQ3erY5JlhgIk6/bevbe7d95VMcr8c35+/v3i4uJXLjOOj4/L/f39o9fX19/F2dnZj7e3t+V6vV5eXV3dDW1ULjBOT08Pi6KY0vkW+ENdmEwm5Wq1WtZ1/bRYLJZDADMkGPo8Hx4e7q6vrxs1zw0Y9EdDrNE/kBogbjBOTk6mVVV9mUwm09Vq1dR1fde10B/AUJOFlnZ3d/GQr5wy4gADtu/t7R0qAHxdQCcYlAEtung4ZNT4PtyHRSnBoKyGjY+Pj09UBi57vMDglFEsGJofsMogORgmxrT/6+Vf+oCh+4FUTA1mRhe6WKGtra2DUBn5gqF8mAqHqQD4EFpd9Am5bvIvNu26wJjNZt9Go1EJG/r4gRDbkzFDH1StJNiCa135C5K+y8vLnya/NHTewwaGLX+hK6yYwRmxfNkxGBh6/gLtY+Vb1myyQCRELy8vTUg49J2oz32fAgxlKDZLOfZHnem4D4J97tFksESaj+dgx4hdK67v7OzAWXb6lz7jhnyGlRk++wJTNKGJFNgSmkmGAMAaWk35QExo1YHhlFESZoQCQFfDlWeoexXLkHPA8XL4lygwXOcDPnT1BaMrGqU8fwkGg65QinAYCkZH/oIQjd9e+6OgaKJnkykpGguGzhiV8fax0Xm4o5Ij0JHj1CsVGJQxyQ53/rVjP7XRUwdTzmM/PSH6bw+EQdPQMwifKOF7D4dMXGObZAR3EBxNXAOFXs8BBrVRbQM2XyKFGp/6/txgYD6w4f7+/kbAaMHAZlHAEDD+FruSqjBDmCHM6AyEIhMCjYAhYJiVIswQZggznNspkYnIRGQiMnEiIDIRmThJItFEZCIyEZk4EfiMMpnNZkfz+fwmxPjU92Z3oLTEachSJROQWcBQX+vRit+maWr0g4zH4wPOVg4bmwYFQ9WVwyBbaYP6Arw1HB0Cg3REsYOBiZVlWbXF9cG1HUNW/LGAQSt88M0+yorm8/ltjMOLKZ7zHTcZGNRYVYXHVbfZtyLHBUo0GCkq/VxG2q6nHL8XGDkrfFzA0FaO0NozbzCG6ACKYQj9rMlWhG5Xj64VDJoPcPuBVEDoz6FJHa7ZSiE/gKE7Qq5SR67J256rN/boFX/vlTs+lf85JsA1pp7Ywb+gzeP5+fm2ACp9qmm5jB3quTRMt5lxU2DXiD+4OwOHmqTPOIod4/F4iv2Qag/bVO6YkhmuxMnHWI57bHPsjCZcWR7HBF3PNGXHpuYdrzwj1y7SNUnb9T5R0QsMOigNT7kPY0xguMKnDcBgMNTDTAc0ufxLa8um41EFgT49bL3B0NNfvLRDnVzZ2hdiqN81JqIA8oPYxuAkYHTJKGXfmIp2eMsLeWFQVPuVvjDJwaADpDilggS2t7fLqqrAvHcZcEiSFQwKDDqB8O6bNstzHv/lyHkGA4M6XlDd9MKRHADQBRscjC7/sl6vS6TEsW2YMQ46KxiULdgxovEl12siYMunAIMaErOysZ8VMAiCAoaAYRaUMEOYIcxwBhuRichEZCIycSIgMhGZOEki0URkIjIRmTgREJmITJwkkWgiMhGZiEycCIhM7DL5Ayk9ZeUW9vR+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubes);
export default __webpack_public_path__ + "static/media/cubes.2e5b35fb06b83f1f2513e0cff5b34d56.svg";
export { ForwardRef as ReactComponent };